import React,{useState} from 'react'
import { dataQuestions } from "./data-questions";
import './faqs.scss'

const Faqs = () => {

    const [valueQuestion, setValueQuestion] = useState(null);

    const handleQuestion = (question, value_index) => {
        if (valueQuestion === null) {
            setValueQuestion(question.idQuestion)

            try {
                window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing :: faqs',
                action: 'desplegar',
                label: question.titleQuestion,
                value: '',
                })
            } catch (error) {
                console.log(error)
            }
        } else if (valueQuestion === value_index) {
            setValueQuestion(null)

            try {
                window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing :: faqs',
                action: 'contraer',
                label: question.titleQuestion,
                value: '',
                })
            } catch (error) {
                console.log(error)
            }

        } else if (valueQuestion !== value_index) {
            setValueQuestion(question.idQuestion)
            
            try {
                window.dataLayer.push({
                event: 'ga_event',
                category: 'ui :: landing :: faqs',
                action: 'desplegar',
                label: question.titleQuestion,
                value: '',
                })
            } catch (error) {
                console.log(error)
            }
        }
    }

  return (
    <div  className="f-container-faqs">
        <div id="preguntasfrecuentes" className="f-container-faqs__ancla" />
        <div id="preguntasfrecuentes" className="f-container-faqs__content">
            <h2>Preguntas Frecuentes</h2>
            <div className="f-container-faqs__content__bot">
                <div className="f-container-faqs__content__bot__question">
                    <div className="f-questions">
                        <div className="f-questions__container">
                            <h3 className="f-questions__container-title">Temas más buscados</h3>
                            <div className="f-questions__container-questionList">
                                {dataQuestions.map((question, index) => (
                                    <div className={'f-questions__container-question ' + `${valueQuestion === index + 1 ? "border-style-active" : ""}`} key={index}>
                                        <div onClick={() => handleQuestion(question, index + 1)} className={'f-questions__container-question__title ' + `${valueQuestion === index + 1 ? "" : "border-style"}`}>
                                            <p className={`${valueQuestion === index + 1 ? "active-question" : null}`}>
                                                {question.titleQuestion}
                                            </p>
                                            <div className={'icon-arrow ' + `${valueQuestion === index + 1 ? "active-arrow" : ""}`}>
                                                <svg width="20" height="20">
                                                    <g transform="matrix(0.0390625 0 0 0.0390625 0 0)">
                                                        <path d="M-1 -1L581 -1L581 401L-1 401L-1 -1z" stroke="none" fill="none" />
                                                        <path fill={`${valueQuestion === index + 1 ? "#D4207B" : "#000000"}`} d="M256 298.3L430.2 131.1C 434.5 126.9 441.6 127 446 131.3L446 131.3L476.6 161.2C 481 165.5 481.1 172.5 476.8 176.7L476.8 176.7L264.1 380.9C 261.9 383.1 258.9 384.1 256 383.9C 253 384 250.1 383 247.9 380.9L247.9 380.9L35.20003 176.7C 30.90003 172.5 31.00003 165.5 35.40003 161.2L35.40003 161.2L66.00003 131.3C 70.40003 127 77.50003 126.9 81.80003 131.1L81.80003 131.1L256 298.3z" stroke="none" fill-rule="nonzero" />
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                        {valueQuestion === index + 1 
                                        ?   <div className="f-questions__container-question__answer">
                                                <p>{question.answerQuestion}</p>
                                            </div>
                                        :   null
                                        }
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Faqs
